import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiAward, FiGlobe, FiHeart, FiUsers } from 'react-icons/fi';
import './About.css';

const About = () => {
  const values = [
    {
      icon: <FiAward />,
      title: 'Exceptional Craftsmanship',
      description: 'Each piece is meticulously crafted by master artisans using the finest materials.'
    },
    {
      icon: <FiGlobe />,
      title: 'Sustainable Luxury',
      description: 'Committed to ethical practices and sustainable production methods.'
    },
    {
      icon: <FiHeart />,
      title: 'Timeless Design',
      description: 'Creating pieces that transcend seasons and trends.'
    },
    {
      icon: <FiUsers />,
      title: 'Client First',
      description: 'Personalized service and attention to every detail.'
    }
  ];

  const timeline = [
    {
      year: '2018',
      title: 'The Beginning',
      description: 'BASICK founded in New York with a vision to redefine contemporary luxury.'
    },
    {
      year: '2020',
      title: 'First Collection',
      description: 'Debut collection presented during New York Fashion Week.'
    },
    {
      year: '2022',
      title: 'Global Expansion',
      description: 'Flagship stores opened in London, Tokyo, and Los Angeles.'
    },
    {
      year: '2024',
      title: 'Sustainability Pledge',
      description: 'Committed to carbon neutrality and ethical sourcing.'
    },
    {
      year: '2026',
      title: 'The Future',
      description: 'Continuing to evolve and define modern luxury.'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-background">
          <img 
            src="/images/lookbook-bg.svg" 
            alt="BASICK atelier"
          />
          <div className="about-hero-overlay"></div>
        </div>
        
        <div className="about-hero-content">
          <h1 className="about-hero-title">
            The Art of <span className="gold-text">Luxury</span>
          </h1>
          <p className="about-hero-description">
            Redefining elegance through exceptional craftsmanship and timeless design.
          </p>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy-section">
        <div className="container">
          <div className="philosophy-grid">
            <div className="philosophy-content">
              <span className="section-tag">Our Philosophy</span>
              <h2 className="philosophy-title">
                Where Artistry Meets Wardrobe
              </h2>
              <p className="philosophy-text">
                BASICK was born from a desire to create clothing that transcends the ordinary. 
                We believe that luxury is not just about price tags—it's about the feeling of 
                wearing something extraordinary, crafted with intention and worn with confidence.
              </p>
              <p className="philosophy-text">
                Each collection is a dialogue between tradition and innovation, between the 
                heritage of couture craftsmanship and the demands of modern life. We work with 
                the world's most skilled artisans to bring visionary designs to life.
              </p>
              <div className="philosophy-signature">
                <span className="signature-name">Alexander Chen</span>
                <span className="signature-title">Founder & Creative Director</span>
              </div>
            </div>
            <div className="philosophy-image">
              <img 
                src="/images/tee-1.svg" 
                alt="BASICK craftsmanship"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag gold">Our Values</span>
            <h2 className="section-title">Defining Modern Luxury</h2>
          </div>
          
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="timeline-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Our Journey</span>
            <h2 className="section-title">The BASICK Story</h2>
          </div>
          
          <div className="timeline">
            {timeline.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-year">{item.year}</div>
                <div className="timeline-content">
                  <h3 className="timeline-title">{item.title}</h3>
                  <p className="timeline-description">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Atelier Section */}
      <section className="atelier-section">
        <div className="atelier-background">
          <div className="container">
            <div className="atelier-content">
              <span className="atelier-tag">The Atelier</span>
              <h2 className="atelier-title">
                Where Ideas Become Form
              </h2>
              <p className="atelier-description">
                Located in the heart of New York's Garment District, our atelier is a sanctuary 
                of creativity and precision. Here, master pattern makers and seamstresses work 
                alongside young designers, ensuring that each piece that bears the BASICK label 
                meets our exacting standards.
              </p>
              <Link to="/contact" className="atelier-btn">
                VISIT US
                <FiArrowRight />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;